import { useEffect } from 'react';
import { overlayKey } from '../../helpers/path';
import { useQueryParams } from '../use-query-params';
import s from './use-flash-element.module.css';

export const useFlashElement = ({ isReady, selector }: { isReady: boolean; selector: string }) => {
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const overlayId = params[overlayKey];

  useEffect(() => {
    if (!isReady) return;

    const id = overlayId?.split('-').pop();
    if (!id) return;

    const element = document.querySelector(selector);
    if (!element) return;

    element.classList.add(s.flash);

    const timeout = setTimeout(() => {
      element.classList.remove(s.flash);
      addQueryParams({ [overlayKey]: undefined });
    }, 4000);

    return () => {
      clearTimeout(timeout);
    };
  }, [overlayId, isReady, params]);
};
